<mat-form-field>
  <input matInput disabled [value]="title" />
  <a [href]="routerLink" *ngIf="userCanViewLink">
    <mat-hint>{{ linkHint }}<mat-icon>open_in_new</mat-icon></mat-hint>
  </a>
</mat-form-field>
